import React from 'react'
import heroImg2 from "../../assets/images/heroImg2.png"
import CountUp from 'react-countup';




const Hero = () => {
  return (
    <section id='about' className=' hero  pt-0 '>
         
        <div className='container pt-14 '>

            <div className='md:flex items-center justify-between sm:flex-col md:flex-row'>
                
                <div className='w-full md:basis-1/2'>
                    <h5 data-aos='fade-right'
                    data-aos-duration='1500'
                    className='text-headingColor font-[600] text-[16px]'>
                        Hello Welcome 
                       
                    </h5>
                    <h1 data-aos='fade-up'
                    data-aos-duration='1500' className='text-headingColor font-[800] text-[1.8rem]
                     sm:text-[40px] leading-[35px] sm:leading-[46px] mt-5'>
                        I'm Ajai Kulkarni
                        <p>Full Stack Developer & Data Scientist</p>
                       
                    
                        

                    </h1>
                    <div data-aos='fade-up'
                    data-aos-duration='1800'
                    data-aos-delay='200'
                    className='flex items-center gap-6 mt-7'>
                        <a href='Kulkarni Ajai Cv.pdf' download='Kulkarni Ajai Cv.pdf'>
                            <button className='button bg-primaryColor text-white font-[500] flex items-center gap-2
                            hover:bg-smallTextColor ease-in duration-300 py-2 px-4 rounded-[8px]'>
                                <i class="ri-mail-line"></i>
                                {""}
                            Download CV {" "}
                            </button>

                        </a>
                        <a className='  hover:text-red-500 text-smallTextColor font-[600] text-[16px] border-b border-solid 
                         border-smallTextColor ' href='#portfolio'>
                            See Portfolio
                        </a>
                    

                    </div>
                    <p
                        data-aos='fade-up'
                        data-aos-duration='1500'
                        className='flex gap-2 text-headingColor mt-14 font-[500] text-[15px] 
                        leading-7 sm:pl-14 sm:pr-10'>
                            <span><i class="ri-apps-fill"></i>
                                </span> 
                                Full Stack Developer looking to work in an organization 
                        that can provide a variety of oppurtunities that allow me to expand my skills and knowledge
                        white working towards achieving the organizational goals. 
                            
                        </p>
                        <div className='flex items-center gap-9 mt-14'>
                            <span className='text-smallTextColor font-[600] text-[15px]'>
                                Follow Me:
                            </span>
                            <span className=''>
                                <a href="https://www.youtube.com/channel/UC27uRFOULQW5zHdH21TABLQ" className='text-smallTextColor text-[18px] font-[600]'>
                                <i class="ri-youtube-fill "></i>
                                </a>

                            </span>
                            <span>
                                <a href="https://github.com/Ajai97" className='text-smallTextColor text-[18px] font-[600]'>
                                <i class="ri-github-fill"></i>
                                </a>

                            </span>
                            <span>
                                <a href="https://www.linkedin.com/in/ajai-kulkarni-84510818b/" className='text-smallTextColor text-[18px] font-[600]'>
                                <i class="ri-linkedin-box-fill"></i>
                                </a>

                            </span>
                            <span >
                                <a href="#instagram" className=' hover:bg-white text-smallTextColor text-[18px] font-[600]'>
                                <i class="ri-instagram-fill"></i>
                                </a>

                            </span>
                            <span>
                                <a href="https://twitter.com/AKgroup26" className='text-smallTextColor text-[18px] font-[600]'>
                                <i class="ri-twitter-x-fill"></i>
                                </a>

                            </span>
                        </div>
                </div>
                <div className='basis-1/2 mt-5 sm:mt-0 width-auto'>
                    <figure className='flex items-center justify-center basis-1/2'>
                        <img src={heroImg2} alt=""/>
                    </figure>
                </div>
                <div className='md:basis-1/5 flex justify-between text-center mt-10 flex-wrap gap-3 
                md:mt-0 md:flex-col md:justify-end md:text-end'>
                    <div className='mb-10'>
                        <h2 className=' text-headingColor font-[700] text-[32px]'>
                            <CountUp start={0} end ={1} duration={2} suffix="+"/>

                        </h2>
                        <h4 className='  text-headingColor font-[600] text-[18px]'>
                            Years Of Experience
                        </h4>

                    </div>
                    <div className='mb-10'>
                        <h2 className='  text-headingColor font-[700] text-[32px]'>
                            <CountUp start={0} end ={13} duration={2} suffix="+"/>

                        </h2>
                        <h4 className='  text-headingColor font-[600] text-[18px]'>
                           Project Completed
                        </h4>

                    </div>


                </div>
            </div>
        </div>
</section>
  )
}

export default Hero